import { FormMapperConfig } from './types';

export const gndMapperConfig: FormMapperConfig = {
  formType: 'gnd',
  
  patterns: {
    'form.gnd.giving': 'youAreGiving',
    'form.gnd.receiving': 'youAreReceiving',
    'form.gnd.office': 'officeInternalUsage'
  },

  fieldConfigs: {
    'youAreGiving': [
      'form.gnd.giving.typeOfRecipient.question',
      'form.gnd.giving.typeOfGift.question',
      'form.gnd.giving.totalAmountInUSD.question',
      'form.gnd.giving.details.question'
    ],
    'youAreReceiving': [
      'form.gnd.receiving.typeOfProvider.question',
      'form.gnd.receiving.typeOfGift.question',
      'form.gnd.receiving.totalAmountInUSD.question',
      'form.gnd.receiving.details.question'
    ],
    'officeInternalUsage': [
      'form.gnd.office.dateOfEvent.question',
      'form.gnd.office.totalAmountInUSD.question',
      'form.gnd.office.details.question'
    ]
  },

  translationKeys: {
    'form.gnd.giving.typeOfRecipient.question': 'gnd.fields.type_of_recipient',
    'form.gnd.giving.typeOfGift.question': 'gnd.fields.type_of_gift',
    'form.gnd.giving.totalAmountInUSD.question': 'gnd.fields.total_amount_usd',
    'form.gnd.giving.details.question': 'common.description',
    'form.gnd.receiving.typeOfProvider.question': 'gnd.fields.type_of_provider',
    'form.gnd.receiving.typeOfGift.question': 'gnd.fields.type_of_gift',
    'form.gnd.receiving.totalAmountInUSD.question': 'gnd.fields.total_amount_usd',
    'form.gnd.receiving.details.question': 'common.description',
    'form.gnd.office.dateOfEvent.question': 'gnd.fields.date_of_event',
    'form.gnd.office.totalAmountInUSD.question': 'gnd.fields.total_amount_usd',
    'form.gnd.office.details.question': 'common.description'
  },

  displayLabels: {
    'form.gnd.giving.typeOfRecipient.question': 'Type of Recipient',
    'form.gnd.giving.typeOfGift.question': 'Type of Gift',
    'form.gnd.giving.totalAmountInUSD.question': 'Total Amount in USD',
    'form.gnd.giving.details.question': 'Description',
    'form.gnd.receiving.typeOfProvider.question': 'Type of Provider',
    'form.gnd.receiving.typeOfGift.question': 'Type of Gift',
    'form.gnd.receiving.totalAmountInUSD.question': 'Total Amount in USD',
    'form.gnd.receiving.details.question': 'Description',
    'form.gnd.office.dateOfEvent.question': 'Date of the event',
    'form.gnd.office.totalAmountInUSD.question': 'Total Amount in USD',
    'form.gnd.office.details.question': 'Description'
  }
};

export type GndCategory = 'youAreGiving' | 'youAreReceiving' | 'officeInternalUsage';
